export default {
  title: 'Danger Zone',
  description: 'Irreversible and destructive actions',
  deleteAccount: {
    title: 'Delete account',
    subtitle: 'Permanently delete your account',
    warning: {
      title: 'This action cannot be undone',
      item1: 'Every session of this account is signed out at once',
      item2: 'You leave every organization you belong to, and the invitations you sent are withdrawn',
      item3: 'Your two-step verification, recovery codes and linked sign-in accounts are removed',
      organizationsTitle: 'Organizations you own',
      organizationsDescription:
        'Deletion is refused while you are the last member able to administer one of these organizations: it would be left with nobody to run it. Delete the organization first, or hand it to another member, from its Danger Zone.',
      deleteOrganization: 'Delete the organization',
    },
    confirm: {
      title: 'Confirm it is you',
      description: 'Enter your password, then type the phrase below.',
      // Compared against the user input to unlock the deletion button: label,
      // placeholder and hint all render this same phrase.
      confirmPhrase: 'DELETE MY ACCOUNT',
      confirmLabel: 'Type {text} to confirm',
      confirmHint: 'Type "{text}" exactly as shown above',
      submit: 'Delete my account permanently',
    },
    lastAdministrator:
      'Your account is the last member able to administer at least one organization. Delete that organization, or hand it to another member, from its Danger Zone, then try again.',
  },
}
